/**
 * 提示用户的自定义属性，不能与已有的核心上报字段重复
 *
 * @file forbiddenWords.js
 * @author leibin@baijia.com
 *
 */

import {isTestReg} from './env';
import {commonParamsFromApp} from './appCommonParam';

let protectedKeys = [
    'env',
    'name',
    // 记录当前使用的哈勃版本信息， 比如2.2.1
    'ver',
    // 当前设备（浏览器）的唯一标识
    'gid',
    // 时间戳
    't',
    // 请求序号
    'req_idx',
    // stay 中固定 at、bt、tt暂不考虑
];

if (Object.keys(commonParamsFromApp).length > 0) {
    protectedKeys = [...protectedKeys, ...Object.keys(commonParamsFromApp).map(key => key.toLowerCase())];
}


/**
 * 如果自定义事件属性含有受保护的上报字段 (name, env, version 等)，就会有warning提示，但是不阻断上报
 *
 * @params {Object} eventAttr 自定义事件上报属性对象
 */
export default function warnForbiddenKeys(eventAttr) {
    if (typeof location === 'object' && isTestReg.test(location.hostname)) {
        setTimeout(() => {
            Object.keys(eventAttr).forEach(key => {
                if (key && protectedKeys.includes(key.toLowerCase())) {
                    console.warn(`请勿用哈勃内部保留字段 ${key} 进行上报，此操作会覆盖原有上报字段。本次日志为 ${JSON.stringify(eventAttr, null, 4)}`);
                }
            });
        }, 100);
    }
}

